module.exports = __webpack_public_path__ + "static/media/400025_02.93ce2806.png";